module.exports = __webpack_public_path__ + "img/ser11.5fb9b514.png";